import { SuspendedUserAlert } from 'modules/accountStatus/components/SuspendedUserAlert';
import { useIsUserSuspended } from 'modules/accountStatus/hooks/useIsUserSuspended';

import { usePageStyles } from './usePageStyles';

export interface PageProps {
  children: React.ReactNode;
  className?: string;
  classes?: Partial<ReturnType<typeof usePageStyles>['classes']>;
}

export const Page = ({
  children,
  className: externalClassName,
  classes: classesOverrides,
}: PageProps) => {
  const hasSuspendedAlert = useIsUserSuspended();

  const { classes, cx } = usePageStyles(undefined, {
    props: { classes: classesOverrides },
  });

  const className = cx(classes.root, externalClassName, {
    [classes.withSuspendedUserAlert]: hasSuspendedAlert,
  });

  return (
    <div className={className}>
      <div className={classes.content}>
        <SuspendedUserAlert className={classes.suspendedUserAlert} />
        {children}
      </div>
    </div>
  );
};
